// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Select, MenuItem } from "@mui/material";
import {
  GridFilterItem,
  GridCellParams,
  GridColDef,
  GridFilterOperator,
} from "@mui/x-data-grid";

export function StatusFilterComponent(props) {
  const { item, applyValue, customOptions } = props;


  return (
    <Select
      value={item.value || ""}
      onChange={(event) => {
        applyValue({ ...item, value: event.target.value });
      }}
      fullWidth
      sx={{ marginTop: 2 }}
    >
      {customOptions?.map((item) => (
        <MenuItem value={item.value}>{item.label}</MenuItem>
      ))}
    </Select>
  );
}

export const createStatusOperator = (customOptions) => ({
  label: "Durum",
  value: "statusSelect",
  getApplyFilterFn: (filterItem: GridFilterItem, column: GridColDef) => {
    if (!filterItem.field || !filterItem.value || !filterItem.operator) {
      return null;
    }
    return (params: GridCellParams): boolean => {
      return params.value === filterItem.value;
    };
  },
  InputComponent: (props) => (
    <StatusFilterComponent {...props} customOptions={customOptions} />
  ),
});
